import { DEVELOPMENT } from '@shared/environments';
import { getCurrentEnvironmentOrDefault } from '@shared/featureFlags/featureFlagContextFactory';

const DEFAULT_LOCAL_WEB_RESERVATIONS_PORT = '4000';

/**
 * The base URL for the customer-facing web-reservations site, used to build
 * shareable links (e.g. an event page URL) from other apps like restaurant
 * admin.
 *
 * In local development, `WEB_CUSTOMER_HOST` is sometimes customized to a LAN
 * IP (e.g. to test the site from a phone on the same network), which breaks
 * links opened on the developer's own machine -- a different origin means a
 * different browser session, so API calls made from that URL fail. Always
 * use localhost in development instead; staging and production keep using
 * the configured `WEB_CUSTOMER_HOST`.
 */
export const getWebCustomerHost = (): string =>
  getCurrentEnvironmentOrDefault() === DEVELOPMENT
    ? `http://localhost:${process.env.WEB_RESERVATIONS_PORT ?? DEFAULT_LOCAL_WEB_RESERVATIONS_PORT}`
    : (process.env.WEB_CUSTOMER_HOST ?? '');
